import {
  lightColors
} from "./chunk-RIYXTX7W.mjs";

// src/receipt.ts
var receiptColors = {
  ink: lightColors.foreground,
  muted: lightColors.mutedForeground,
  line: lightColors.border,
  fill: lightColors.muted,
  accent: lightColors.primary,
  credit: lightColors.success
};

export {
  receiptColors
};
